import { Flex, Image } from "antd";
import { FC } from "react";

import { getFileUrl } from "@/utils/file/getFileUrl";

import { StyledImageWrapper } from "./Styled";

interface ImageRowListProps {
    images: string[];
}

export const ImageRowList: FC<ImageRowListProps> = ({ images }) => {
    return (
        <Image.PreviewGroup>
            <Flex wrap="wrap" gap="12px">
                {images.map((photo) => (
                    <StyledImageWrapper key={photo}>
                        <Image src={getFileUrl(photo)} width={80} height={80} />
                    </StyledImageWrapper>
                ))}
            </Flex>
        </Image.PreviewGroup>
    );
};
